import { AxiosInstance } from 'axios';
import { ExclusiveAccessServiceModel, initExclusiveAccessService } from './exclusiveAccessService';

export interface SharedServiceModel {
  exclusiveAccess: ExclusiveAccessServiceModel;
}

export const initSharedService = (axios: AxiosInstance): SharedServiceModel => ({
  exclusiveAccess: initExclusiveAccessService(axios),
});
